import { ApiConfig } from "../../ApiServices/AuthAction/ApiConfig";
import { ApiCallDelete, ApiCallGET, ApiCallPost, ApiCallPut } from "../../ApiServices/AuthAction/Apicall";

const AuthService = {

  register: async (emailId, passsword, userId) => {
    const { baseUrl, register } = ApiConfig;
    const url = baseUrl + register;
    const params = {
      emailId: emailId?.toLowerCase(),
      password: passsword,
      user_id: userId
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  login: async (emailId, passsword) => {
    const { baseUrl, signIn } = ApiConfig;
    const url = baseUrl + signIn;
    const params = {
      emailId: emailId?.toLowerCase(),
      password: passsword
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },


  getOtp: async (type, email) => {
    const { baseOtpUrl, verify_otp } = ApiConfig;
    const url = baseOtpUrl + verify_otp;
    const params = {
      email: email?.toLowerCase(),
      type: type,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  create_pin: async (type, email) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseOtpUrl, create_pin } = ApiConfig;
    const url = baseOtpUrl + create_pin;
    const params = {
      email: email?.toLowerCase(),
      type: type,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },


  forgotPassword: async (emailId, otp, newPassword, confirmNewPassword) => {
    const { baseUrl, forgotPassword } = ApiConfig;
    const url = baseUrl + forgotPassword;
    const params = {
      emailId: emailId?.toLowerCase(),
      otp: otp,
      newPassword: newPassword,
      confirmNewPassword: confirmNewPassword
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return ApiCallPost(url, params, headers);
  },

  changePassword: async (otp, password, confirmPassword, emailId) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, changepassword } = ApiConfig;
    const url = baseUrl + changepassword;
    const params = {
      emailId: emailId?.toLowerCase(),
      otp: otp,
      newPassword: password,
      confirmNewPassword: confirmPassword
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPut(url, params, headers);
  },

  getDetails: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, userDetails } = ApiConfig;
    const url = baseUrl + userDetails;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },
  getHistoryData: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, getHistoryData } = ApiConfig;
    const url = baseUrl + getHistoryData;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  updateProfile: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseUrl, editProfile } = ApiConfig;
    const url = baseUrl + editProfile;
    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': token
    };
    return ApiCallPost(url, formData, headers);
  },

  depositAmount: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseUrl, deposit_amount } = ApiConfig;
    const url = baseUrl + deposit_amount;
    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': token
    };
    return ApiCallPost(url, formData, headers);
  },

  withdrawAmount: async (formData) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, withdrawal_amount } = ApiConfig;
    const url = baseUrl + withdrawal_amount;
    const params = {
      chain: formData?.chain,
      withdrawal_address: formData?.withdrawAddress,
      amount: formData?.amount,
      user_pin: formData?.userPin,
      otp: formData?.verificationCode,
      address: formData?.chainAddress,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },

  walletBalance: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, wallet_balance } = ApiConfig;
    const url = baseUrl + wallet_balance;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  masterListing: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, get_master_listing } = ApiConfig;
    const url = baseUrl + get_master_listing;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  viewMasterDetail: async (master_id) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, view_master } = ApiConfig;
    const url = `${baseUrl}${view_master}/${master_id}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  tradeDetails: async (master_id) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, master_trade_list } = ApiConfig;
    const url = baseUrl + master_trade_list;
    const params = { master_id };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },

  fetchMasterBalance: async (masterId) => {
    const Authtoken = sessionStorage.getItem("token");
    const { weburl, fetch_master_balance } = ApiConfig;
    const url = weburl + fetch_master_balance + `?id=${masterId}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  getMasterTransaction: async (masterId) => {
    const Authtoken = sessionStorage.getItem("token");

    const { baseUrl, master_transaction } = ApiConfig;
    const url = `${baseUrl}${master_transaction}/${masterId}`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  check_master_followed: async (masterId) => {
    const Authtoken = sessionStorage.getItem("token");

    const { baseUrl, check_master_followed } = ApiConfig;
    const url = `${baseUrl}${check_master_followed}/${masterId}`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  followMaster: async (amount, master_id) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, follow_master } = ApiConfig;
    const url = baseUrl + follow_master;
    const params = { amount, master_id };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },

  removeMaster: async (master_id) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, remove_master } = ApiConfig;
    const url = baseUrl + remove_master;
    const params = { master_id };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },

  withdrawalHistory: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, withdrawal_list } = ApiConfig;
    const url = baseUrl + withdrawal_list;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  deleteWithdrawal: async (id) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, withdrawal_delete } = ApiConfig;
    const url = baseUrl + withdrawal_delete + `/${id}`;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallDelete(url, headers);
  },

  getdepositHistory: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, deposit_list } = ApiConfig;
    const url = baseUrl + deposit_list;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },


  getCalCulationMaster: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, calculation_master } = ApiConfig;
    const url = baseUrl + calculation_master;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },


  submitKyc: async (formData) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, identityKyc } = ApiConfig;
    const url = baseUrl + identityKyc;

    const params = {
      name: String(formData?.fullName || ''),
      phone_number: String(formData?.phoneNumber || ''),
      dob: String(formData?.dateOfBirth || ''),
      country_code: String(formData?.countryCode || ''),
      country: String(formData?.country || ''),
      state: String(formData?.state || ''),
      city: String(formData?.city || ''),
      user_id: String(formData?.userId || ''),
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },


  submitKycManual: async (formData) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, user_documents_kyc } = ApiConfig;
    const url = baseUrl + user_documents_kyc;
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, formData, headers);
  },

  changePinNumber: async (otp, pinNumber, confirmPinNumber) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, changePinNumber } = ApiConfig;
    const url = baseUrl + changePinNumber;
    const params = {
      otp: otp,
      new_pin: pinNumber,
      confirm_new_pin: confirmPinNumber
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },


  addInvestmentAmount: async (amount, master_id) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, add_investment } = ApiConfig;
    const url = baseUrl + add_investment;
    const params = { amount: +amount, master_id };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },

  reduceAmountdetail: async (amount, master_id) => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, reduce_investment } = ApiConfig;
    const url = baseUrl + reduce_investment;
    const params = { amount, master_id };
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallPost(url, params, headers);
  },

  master_deposit_withdraw: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, master_deposit_withdrawal_listing } = ApiConfig;
    const url = baseUrl + master_deposit_withdrawal_listing;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  getTermsCondition: async () => {
    const Authtoken = sessionStorage.getItem("token");
    const { baseUrl, view_term_condition } = ApiConfig;
    const url = baseUrl + view_term_condition;
    const headers = {
      "Content-Type": "application/json",
      Authorization: Authtoken,
    };
    return ApiCallGET(url, headers);
  },

  getTicketList: async () => {
    const token = sessionStorage.getItem("token");
    const { baseProfile, getTicketList } = ApiConfig;
    const url = baseProfile + getTicketList;
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallGET(url, headers);
  },

  createTicket: async (formData) => {
    const token = sessionStorage.getItem("token");
    const { baseUrl, createTicket } = ApiConfig;
    const url = baseUrl + createTicket;
    const headers = {
      "Content-Type": "multipart/form-data",
      Authorization: token,
    };
    return ApiCallPost(url, formData, headers);
  },

  seenTicket: async (userId) => {
    const token = sessionStorage.getItem("token");
    const { baseProfile, seenTicket } = ApiConfig;
    const url = baseProfile + seenTicket;
    const params = {
      user_id: userId,
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: token,
    };
    return ApiCallPost(url, params, headers);
  },

};

export default AuthService;
